import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type { AffiliateSummary, WithdrawalList } from '../types/affiliate.types';

/** 403 for a Member, 404 without an affiliate account. */
export const fetchAffiliate = async (): Promise<AffiliateSummary> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.affiliate}`);
};

/** Riwayat; 403 for a Member, 404 without an affiliate account. */
export const fetchWithdrawals = async (): Promise<WithdrawalList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.affiliateWithdrawals}`);
};
